/** Les trois étapes du dîner, dans l'ordre de la soirée. */
export const ETAPES = ['entree', 'plat', 'dessert'] as const;
export type Etape = (typeof ETAPES)[number];

export interface EtapeInfo {
  readonly label: string;
  readonly num: 1 | 2 | 3;
  /** « à l'entrée », « au plat », « au dessert » */
  readonly au: string;
  readonly main: string;
  readonly dark: string;
  readonly tint: string;
}

/** Code couleur constant, réutilisé partout (HANDOFF « Système visuel »). */
export const ETAPE_INFO: Readonly<Record<Etape, EtapeInfo>> = {
  // Charte Lions Clubs International : bleu 287, violet 2612, vert 3405 (variantes dark/tint dérivées pour le contraste).
  entree: { label: 'Entrée', num: 1, au: "à l'entrée", main: '#00338D', dark: '#0D2240', tint: '#DCE6F7' },
  plat: { label: 'Plat', num: 2, au: 'au plat', main: '#7A2582', dark: '#5C1B62', tint: '#F1E4F3' },
  dessert: { label: 'Dessert', num: 3, au: 'au dessert', main: '#00784A', dark: '#005A38', tint: '#DBF2E6' },
};

export function estEtape(x: unknown): x is Etape {
  return typeof x === 'string' && (ETAPES as readonly string[]).includes(x);
}
